var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import * as d3 from 'd3';
import isEqual from 'lodash.isequal';
import ScalerContext from '../../context/Scaler';
import GriffPropTypes from '../../utils/proptypes';
import Axes from '../../utils/Axes';

var propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  itemIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired).isRequired,
  zoomAxes: PropTypes.shape({
    x: PropTypes.bool,
    y: PropTypes.bool,
    time: PropTypes.bool
  }).isRequired,

  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  onMouseMove: PropTypes.func,
  onMouseOut: PropTypes.func,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  /**
   * This is a callback which will be called whenever there is a touchmove event
   * with only one touch. This is used to keep the rule in the same x-position
   * (in terms of pixels) on the screen while pans happen by dragging.
   *
   * {@code (offsetX, offsetY) => void}
   */
  // FIXME: Remove this bit and move the business logic to the apps.
  onTouchMove: PropTypes.func,
  onTouchMoveEnd: PropTypes.func,

  // These are provided by Griff.
  updateDomains: GriffPropTypes.updateDomains.isRequired,
  subDomainsByItemId: GriffPropTypes.subDomainsByItemId.isRequired
};

var defaultProps = {
  onMouseDown: null,
  onMouseUp: null,
  onMouseMove: null,
  onMouseOut: null,
  onClick: null,
  onDoubleClick: null,
  onTouchMove: null,
  onTouchMoveEnd: null
};

var ZoomRect = function (_React$Component) {
  _inherits(ZoomRect, _React$Component);

  function ZoomRect() {
    var _temp, _this, _ret;

    _classCallCheck(this, ZoomRect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onTouchStart = function () {
      var touches = d3.event.touches;

      if (touches.length === 1) {
        var _this$lastTouch;

        var touch = touches[0];
        var x = touch.pageX,
            y = touch.pageY;

        _this.lastTouch = (_this$lastTouch = {}, _this$lastTouch[Axes.time] = x, _this$lastTouch[Axes.x] = x, _this$lastTouch[Axes.y] = y, _this$lastTouch);
      } else if (touches.length === 2) {
        var _this$lastDeltas;

        var touchOne = touches[0],
            touchTwo = touches[1];

        var _this$getOffset = _this.getOffset(touchOne),
            touchOneX = _this$getOffset.x,
            touchOneY = _this$getOffset.y;

        var _this$getOffset2 = _this.getOffset(touchTwo),
            touchTwoX = _this$getOffset2.x,
            touchTwoY = _this$getOffset2.y;

        _this.lastDeltas = (_this$lastDeltas = {}, _this$lastDeltas[Axes.time] = Math.abs(touchOneX - touchTwoX), _this$lastDeltas[Axes.x] = Math.abs(touchOneX - touchTwoX), _this$lastDeltas[Axes.y] = Math.abs(touchOneY - touchTwoY), _this$lastDeltas);
      }
    }, _this.onTouchMove = function () {
      var _totalDistances;

      var _this$props = _this.props,
          width = _this$props.width,
          height = _this$props.height;


      var totalDistances = (_totalDistances = {}, _totalDistances[Axes.time] = width, _totalDistances[Axes.x] = width, _totalDistances[Axes.y] = -height, _totalDistances);

      var touches = d3.event.touches;

      var updates = null;
      if (touches.length === 1) {
        // If there was only one touch, then it was a drag event.
        updates = _this.performTouchDrag(touches, totalDistances);
      } else if (touches.length === 2) {
        // If there were two, then it is a zoom event.
        updates = _this.performTouchZoom(touches, totalDistances);
      } else {
        // We don't support more complicated gestures.
      }
      if (updates) {
        _this.props.updateDomains(updates);
      }
      if (_this.props.onTouchMove) {
        _this.props.onTouchMove();
      }
    }, _this.onTouchEnd = function () {
      var touches = d3.event.touches;

      if (touches.length === 0) {
        _this.lastTouch = null;
      } else if (touches.length === 1) {
        var _this$lastTouch2;

        _this.lastDeltas = null;
        var touch = touches[0];
        var x = touch.pageX,
            y = touch.pageY;

        _this.lastTouch = (_this$lastTouch2 = {}, _this$lastTouch2[Axes.time] = x, _this$lastTouch2[Axes.x] = x, _this$lastTouch2[Axes.y] = y, _this$lastTouch2);
      } else {
        // We don't support more complicated gestures, so any more than 2 fingers
        // touching the screen are ignored.
      }
      if (_this.props.onTouchMoveEnd) {
        _this.props.onTouchMoveEnd();
      }
    }, _this.getOffset = function (_ref) {
      var pageX = _ref.pageX,
          pageY = _ref.pageY;

      var _this$zoomNode$getBou = _this.zoomNode.getBoundingClientRect(),
          boundingX = _this$zoomNode$getBou.x,
          boundingY = _this$zoomNode$getBou.y;

      return {
        x: pageX - boundingX,
        y: pageY - boundingY
      };
    }, _this.performTouchDrag = function (touches, totalDistances) {
      var _newTouchPosition;

      var _this$props2 = _this.props,
          itemIds = _this$props2.itemIds,
          subDomainsByItemId = _this$props2.subDomainsByItemId,
          zoomAxes = _this$props2.zoomAxes;
      var touch = touches[0];

      var newTouchPosition = (_newTouchPosition = {}, _newTouchPosition[Axes.time] = touch.pageX, _newTouchPosition[Axes.x] = touch.pageX, _newTouchPosition[Axes.y] = touch.pageY, _newTouchPosition);
      var updates = {};
      itemIds.forEach(function (itemId) {
        updates[itemId] = {};
        Axes.ALL.filter(function (axis) {
          return zoomAxes[axis];
        }).forEach(function (axis) {
          var subDomain = (subDomainsByItemId[itemId] || {})[axis];
          var subDomainRange = subDomain[1] - subDomain[0];
          var newSubDomain = null;
          var percentMovement = subDomainRange * ((_this.lastTouch[axis] - newTouchPosition[axis]) / totalDistances[axis]);
          newSubDomain = subDomain.map(function (bound) {
            return bound + percentMovement;
          });
          if (newSubDomain) {
            updates[itemId][axis] = newSubDomain;
          }
        });
      });
      _this.lastTouch = _extends({}, newTouchPosition);
      return updates;
    }, _this.performTouchZoom = function (touches, totalDistances) {
      var _centers, _deltas, _multipliers, _measurements;

      var _this$props3 = _this.props,
          itemIds = _this$props3.itemIds,
          subDomainsByItemId = _this$props3.subDomainsByItemId,
          zoomAxes = _this$props3.zoomAxes,
          width = _this$props3.width,
          height = _this$props3.height;
      var touchOne = touches[0],
          touchTwo = touches[1];

      var _this$getOffset3 = _this.getOffset(touchOne),
          touchOneX = _this$getOffset3.x,
          touchOneY = _this$getOffset3.y;

      var _this$getOffset4 = _this.getOffset(touchTwo),
          touchTwoX = _this$getOffset4.x,
          touchTwoY = _this$getOffset4.y;

      var centers = (_centers = {}, _centers[Axes.time] = (touchOneX + touchTwoX) / 2, _centers[Axes.x] = (touchOneX + touchTwoX) / 2, _centers[Axes.y] = (touchOneY + touchTwoY) / 2, _centers);
      var deltas = (_deltas = {}, _deltas[Axes.time] = Math.abs(touchOneX - touchTwoX), _deltas[Axes.x] = Math.abs(touchOneX - touchTwoX), _deltas[Axes.y] = Math.abs(touchOneY - touchTwoY), _deltas);
      // These are used to multiply the zoomFactor in each direction. These need
      // to be treated separately because height is measured inverted from width.
      // That is, a point lower on the screen (touching a lower axis value) has a
      // higher Y pixel value than a point above it (one which is touching a
      // higher axis value). Conversely, points along the time and x axes have
      // x values which match the direction of the pixel values.
      // The inversion (or lack thereof) needs to happen because when the
      // distance between the fingers decreases, we want the subdomain to increase
      // so the value needs to be inverted. (Phew!)
      var multipliers = (_multipliers = {}, _multipliers[Axes.time] = -1, _multipliers[Axes.x] = -1, _multipliers[Axes.y] = 1, _multipliers);
      // This is almost the same as the `totalDistances` object, except the height
      // is un-inverted for y axis.
      var measurements = (_measurements = {}, _measurements[Axes.time] = width, _measurements[Axes.x] = width, _measurements[Axes.y] = height, _measurements);

      var updates = {};
      itemIds.forEach(function (itemId) {
        updates[itemId] = {};
        Axes.ALL.filter(function (axis) {
          return zoomAxes[axis] && _this.lastDeltas[axis];
        }).forEach(function (axis) {
          var subDomain = (subDomainsByItemId[itemId] || {})[axis];
          var subDomainRange = subDomain[1] - subDomain[0];
          var percentFromEnd = centers[axis] / measurements[axis];

          var zoomFactor = multipliers[axis] * ((deltas[axis] - _this.lastDeltas[axis]) / totalDistances[axis]);

          // Figure out the value on the scale where the mouse is so that the
          // new subdomain does not shift.
          var valueAtCenter = subDomain[0] + subDomainRange * percentFromEnd;

          // How big the next subdomain is going to be
          var newSpan = subDomainRange * (1 + zoomFactor);

          // Finally, place this new span into the subdomain, centered about the
          // mouse, and correctly (proportionately) split above & below so that
          // theaxis is stable.
          var start = valueAtCenter - newSpan * percentFromEnd;
          var end = valueAtCenter + newSpan * (1 - percentFromEnd);
          updates[itemId][axis] = [Math.min(start, end), Math.max(end, start)];
        });
      });
      _this.lastDeltas = _extends({}, deltas);
      return updates;
    }, _this.syncZoomingState = function () {
      var zoomAxes = _this.props.zoomAxes;

      if (Object.keys(zoomAxes).find(function (axis) {
        return zoomAxes[axis];
      })) {
        _this.rectSelection.on('touchend', _this.onTouchEnd, true);
        _this.rectSelection.on('touchmove', _this.onTouchMove, true);
        _this.rectSelection.on('touchstart', _this.onTouchStart, true);
        _this.rectSelection.call(_this.zoom.on('zoom', _this.zoomed));
        _this.rectSelection.on('dblclick.zoom', null);
      } else {
        _this.rectSelection.on('.zoom', null);
      }
    }, _this.zoomed = function () {
      var _totalDistances2, _movements, _percents;

      var _this$props4 = _this.props,
          zoomAxes = _this$props4.zoomAxes,
          itemIds = _this$props4.itemIds,
          width = _this$props4.width,
          height = _this$props4.height;
      var sourceEvent = d3.event.sourceEvent;


      var totalDistances = (_totalDistances2 = {}, _totalDistances2[Axes.time] = width, _totalDistances2[Axes.x] = width, _totalDistances2[Axes.y] = height, _totalDistances2);

      var movements = (_movements = {}, _movements[Axes.time] = -sourceEvent.movementX, _movements[Axes.x] = -sourceEvent.movementX, _movements[Axes.y] = sourceEvent.movementY, _movements);

      var percents = (_percents = {}, _percents[Axes.time] = sourceEvent.offsetX / width, _percents[Axes.x] = sourceEvent.offsetX / width, _percents[Axes.y] = (height - sourceEvent.offsetY) / height, _percents);

      var updates = {};
      itemIds.forEach(function (itemId) {
        updates[itemId] = {};
        Axes.ALL.filter(function (axis) {
          return zoomAxes[axis];
        }).forEach(function (axis) {
          var subDomain = (_this.props.subDomainsByItemId[itemId] || {})[axis];
          var subDomainRange = subDomain[1] - subDomain[0];
          var newSubDomain = null;
          if (sourceEvent.deltaY) {
            // This is a zoom event.
            var deltaMode = sourceEvent.deltaMode,
                deltaY = sourceEvent.deltaY;

            var percentFromEnd = percents[axis];

            // This was borrowed from d3-zoom.
            var zoomFactor = deltaY * (deltaMode ? 120 : 1) / 500;

            // Figure out the value on the scale where the mouse is so that the
            // new subdomain does not shift.
            var valueAtMouse = subDomain[0] + subDomainRange * percentFromEnd;

            // How big the next subdomain is going to be
            var newSpan = subDomainRange * (1 + zoomFactor);

            // Finally, place this new span into the subdomain, centered about the
            // mouse, and correctly (proportionately) split above & below so that
            // the axis is stable.
            var start = valueAtMouse - newSpan * percentFromEnd;
            var end = valueAtMouse + newSpan * (1 - percentFromEnd);
            newSubDomain = [Math.min(start, end), Math.max(end, start)];
          } else if (movements[axis]) {
            // This is a drag event.
            var percentMovement = subDomainRange * (movements[axis] / totalDistances[axis]);
            newSubDomain = subDomain.map(function (bound) {
              return bound + percentMovement;
            });
          }
          if (newSubDomain) {
            updates[itemId][axis] = newSubDomain;
          }
        });
      });
      _this.props.updateDomains(updates);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ZoomRect.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        width = _props.width,
        height = _props.height;

    this.zoom = d3.zoom().translateExtent([[0, 0], [width, height]]).extent([[0, 0], [width, height]]);
    this.rectSelection = d3.select(this.zoomNode);
    this.syncZoomingState();
  };

  ZoomRect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevZoomAxes = prevProps.zoomAxes;
    var currZoomAxes = this.props.zoomAxes;

    if (!isEqual(prevZoomAxes, currZoomAxes)) {
      this.syncZoomingState();
    }
  };

  // TODO: A lot of this is duplicated with `zoomed` -- maybe they can be
  // consolidated?


  /**
   * {@link #zoomed()} is called when D3 is handling the zoom -- such as with
   * a pointing device. However, {@link #onTouchMove()} is used to handle events
   * with touch sources (such as fingers on a touchscreen).
   */


  ZoomRect.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        width = _props2.width,
        height = _props2.height,
        onClick = _props2.onClick,
        onMouseMove = _props2.onMouseMove,
        onMouseOut = _props2.onMouseOut,
        onMouseDown = _props2.onMouseDown,
        onMouseUp = _props2.onMouseUp,
        onDoubleClick = _props2.onDoubleClick;

    return React.createElement('rect', {
      ref: function ref(_ref2) {
        _this2.zoomNode = _ref2;
      },
      pointerEvents: 'all',
      fill: 'none',
      width: width,
      height: height,
      onClick: onClick,
      onMouseMove: onMouseMove,
      onBlur: onMouseMove,
      onMouseOut: onMouseOut,
      onMouseDown: onMouseDown,
      onMouseUp: onMouseUp,
      onDoubleClick: onDoubleClick
    });
  };

  return ZoomRect;
}(React.Component);

ZoomRect.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
ZoomRect.defaultProps = defaultProps;

export default (function (props) {
  return React.createElement(
    ScalerContext.Consumer,
    null,
    function (_ref3) {
      var domainsByItemId = _ref3.domainsByItemId,
          subDomainsByItemId = _ref3.subDomainsByItemId,
          updateDomains = _ref3.updateDomains;
      return React.createElement(ZoomRect, _extends({}, props, {
        domainsByItemId: domainsByItemId,
        subDomainsByItemId: subDomainsByItemId,
        updateDomains: updateDomains
      }));
    }
  );
});